import React from 'react';
import { FormControlLabel, MenuItem, Checkbox, Menu, Divider } from '@mui/material';

interface CheckboxSettingsMenuProps {
  anchorEl: HTMLElement | null;
  handleMenuClose: () => void;
  settings: any;
  setSettings: (settings: any) => void;
  settingsLabel: any;
}

export const CheckboxSettingsMenu = ({
  anchorEl,
  handleMenuClose,
  settings,
  setSettings,
  settingsLabel,
}: CheckboxSettingsMenuProps): JSX.Element => {
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({ ...settings, [event.target.name]: event.target.checked });
  };

  const handleSelectAll = () => {
    const allSelected = Object.keys(settings).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {} as any);
    setSettings(allSelected);
  };

  const handleDeselectAll = () => {
    const allDeselected = Object.keys(settings).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {} as any);
    setSettings(allDeselected);
  };

  const allSelected = Object.values(settings).every((value) => value === true);
  const noneSelected = Object.values(settings).every((value) => value === false);

  const handleSelectDeselectAll = () => {
    if (allSelected || (!allSelected && !noneSelected)) {
      handleDeselectAll();
    } else {
      handleSelectAll();
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}>
      {Object.keys(settings).map((key) => (
        <MenuItem key={key} sx={{ paddingLeft: '0px', paddingRight: '16px' }}>
          <FormControlLabel
            labelPlacement="start"
            control={<Checkbox checked={settings[key]} name={key} onChange={handleToggleChange} size="small" />}
            label={settingsLabel[key]}
            slotProps={{
              typography: {
                sx: {
                  width: '188px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  paddingRight: '16px',
                },
              },
            }}
          />
        </MenuItem>
      ))}
      <Divider />
      <MenuItem sx={{ paddingLeft: '0px', paddingRight: '16px' }}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <Checkbox
              checked={allSelected}
              indeterminate={!allSelected && !noneSelected}
              onChange={handleSelectDeselectAll}
              size="small"
            />
          }
          label="Select/Deselect All"
          slotProps={{
            typography: {
              sx: {
                width: '188px',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                paddingRight: '16px',
              },
            },
          }}
        />
      </MenuItem>
    </Menu>
  );
};

export default CheckboxSettingsMenu;
